import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import EyeIcon from 'icons/Eye.icon';
import ClockIcon from 'icons/Clock.icon';
import utils from 'utils';
import MessageIcon from 'icons/Message.icon';
import StarIcon from 'icons/Star.icon';
import ResolvePopup from 'components/ResolvePopup';
import InformationcircleIcon from 'icons/Informationcircle.icon';

import './DisplayListingAnalitics.styles.scss';
import './DisplayListingAnalitics.styles.responsive.scss';

type DisplayListingAnaliticsProps = {
  className?: string;
  timeSpentCounter: number;
  viewsCounter: number;
  enquiriesCounter: number;
  watchlistCounter: number;
  watchlistUsers?: string[];
};

const DisplayListingAnalitics: React.FC<DisplayListingAnaliticsProps> = (
  props,
) => {
  const {
    className,
    timeSpentCounter,
    viewsCounter,
    enquiriesCounter,
    watchlistCounter,
    watchlistUsers = [],
  } = props;
  const { t } = useTranslation();

  const classes = classNames('display-listing-analitics', className);

  const timeSpentTranslated = useMemo(
    () => utils.humanizeSeconds(timeSpentCounter),
    [timeSpentCounter],
  );

  return (
    <div className={classes}>
      <p className="display-listing-analitics__stat">
        <EyeIcon />
        <span>{viewsCounter}</span>
        <span>{t('views')}</span>
      </p>
      <p className="display-listing-analitics__stat">
        <ClockIcon />
        {timeSpentTranslated.count ? (
          <>
            <span>
              {t(timeSpentTranslated.type, {
                count: timeSpentTranslated.count,
              })}
            </span>
            <span>{t('timeOnListing')}</span>
          </>
        ) : (
          <span>{t('noTimeTrackedListing')}</span>
        )}
      </p>
      <p className="display-listing-analitics__stat">
        <MessageIcon />
        <span>{enquiriesCounter}</span>
        <span>{t('enquiries')}</span>
      </p>
      <div className="display-listing-analitics__stat">
        <StarIcon />
        <span>{watchlistCounter}</span>
        <span>{t('shortlisted')}</span>
        {!!watchlistUsers.length && (
          <ResolvePopup
            onHover
            popupContent={
              <ul className="res-watchlisted-users-list">
                {watchlistUsers.map((watchlistUser) => (
                  <li key={watchlistUser}>{watchlistUser}</li>
                ))}
              </ul>
            }
          >
            <InformationcircleIcon />
          </ResolvePopup>
        )}
      </div>
    </div>
  );
};

export default DisplayListingAnalitics;
